import type { WizardTileConfig } from '../types/tileConfig';
import type { WizardNode } from '../types/wizardTypes';
import StepGenericTile from '../steps/StepGenericTile';

function isWizardTileConfig(value: unknown): value is WizardTileConfig {
  return (
    isRecord(value) &&
    typeof value.label === 'string' &&
    typeof value.value === 'string' &&
    typeof value.urlValue === 'string' &&
    typeof value.iconComponent === 'string'
  );
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

export function getWizardTileConfigs(
  node: WizardNode
): WizardTileConfig[] | undefined {
  if (node.componentClass !== StepGenericTile) {
    return undefined;
  }
  const { tileConfigs } = node.props;
  if (!Array.isArray(tileConfigs)) {
    return undefined;
  }
  return tileConfigs.filter(isWizardTileConfig);
}

export function getWizardChildNode(
  node: WizardNode,
  index: number
): WizardNode | undefined {
  return node.nodes?.[index];
}
